// In km.
export const SERVICE_POINT_DISPLAY_RADIUS = {
  min: 0.5,
  max: 15
};

export const DEFAULT_SERVICE_POINT_DISPLAY_RADIUS = 2.5;
